@if (compare) {
  <div class="product-list-item">
    <!-- discontinued product tag -->
    @if (isProductDiscontinuedInRegion) {
      <p class="product-discontinued alert-danger">
        <span class="mr-2"
          ><i class="fa-solid fa-ban pr-2"></i
          ><span>{{ 'shared.discontinuedProduct.discontinuedTag' | cxTranslate }}</span></span
          >@if (product.replacementProduct) {
          <span class="message">{{
            'shared.discontinuedProduct.infoMessage' | cxTranslate
          }}</span>
        }
      </p>
    }
    <!-- product card -->
    <div class="row">
      <div class="col-12 col-md-4">
        <a
          [routerLink]="{ cxRoute: 'product', params: product } | cxUrl"
          class="cx-product-image-container"
          tabindex="-1"
          >
          <cx-media
            class="cx-product-image"
            [container]="product.images?.PRIMARY || product.images"
            [alt]="product.summary"
          ></cx-media>
        </a>
      </div>
      <div class="col-12 col-md-8">
        @if (product.variantOptions) {
          <cx-variant-style-icons
            [variants]="product.variantOptions"
          ></cx-variant-style-icons>
        }
        <div class="row">
          <div class="col-12 col-md-8">
            <a
              [routerLink]="{ cxRoute: 'product', params: product } | cxUrl"
              class="cx-product-name"
              [innerHtml]="product.nameHtml"
            ></a>
            @if (product.code) {
              <p class="cx-product-code">{{ product?.code }}</p>
            }
            @if (userPermissionService.showPrice) {
              <div class="cx-product-price" aria-label="Product price">
                {{ product.price?.formattedValue }}
              </div>
            }
            <p class="cx-product-summary" [innerHtml]="product.summary">
              {{ product.summary }}
            </p>
          </div>
          <div class="col-12 col-md-4">
            @if (userPermissionService.addToCart) {
              <app-custom-add-to-cart
                [showQuantity]="false"
                [product]="product"
              ></app-custom-add-to-cart>
            }
            <button
              class="btn btn-light btn-block top-margin"
              [routerLink]="{ cxRoute: 'product', params: product } | cxUrl"
              >
              View product
            </button>
            @if (compare) {
              <mat-slide-toggle class="top-margin" appCompare [productToCompare]="product">
                Add to compare
              </mat-slide-toggle>
            }
          </div>
        </div>
      </div>
    </div>
    @if (isProductDiscontinuedInRegion) {
      <app-custom-product-replacement
        [currentProduct]="product"
        [compare]="true"
      ></app-custom-product-replacement>
    }
  </div>
}

@if (!compare) {
  <div class="product-list-item">
    <div class="row">
      <div class="col-12 col-md-2">
        <a
          [routerLink]="{ cxRoute: 'product', params: product } | cxUrl"
          class="cx-product-image-container"
          tabindex="-1"
          >
          <cx-media class="cx-product-image" [container]="product.images?.PRIMARY" [alt]="product.summary"></cx-media>
        </a>
      </div>
      <div class="col-12 col-md-10">
        <div class="row">
          <div class="col-12 col-sm-12 col-md-4 col-lg-5 col-xl-6">
            <a
              [routerLink]="{ cxRoute: 'product', params: product } | cxUrl"
              class="cx-product-name"
              [innerHtml]="product.nameHtml"
            ></a>
            <p class="cx-product-summary" [innerHtml]="product.description">
              {{ product.description }}
            </p>
          </div>
          <div class="col-12 col-sm-12 col-md-2 col-lg-2 col-xl-2">{{ product.productSize }}</div>
          <div class="col-12 col-sm-12 col-md-2 col-lg-2 col-xl-2">
            @if (userPermissionService.showPrice) {
              <div class="cx-product-price" aria-label="Product price">
                {{ product.price?.formattedValue }}
              </div>
            }
          </div>
          <div class="col-12 col-sm-12 col-md-4 col-lg-3 col-xl-2">
            @if (userPermissionService.addToCart) {
              <app-custom-add-to-cart
                [showQuantity]="false"
                [product]="product"
                buttonClass="btn-small"
              ></app-custom-add-to-cart>
            }
            <button
              class="btn btn-small btn-light btn-block top-margin"
              [routerLink]="{ cxRoute: 'product', params: product } | cxUrl"
              >
              View product
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
}
